import { useOnlineStore } from './../stores/online';
import { useWebportalStore } from './../stores/webportal';
import { useAuthStore } from '@/stores/auth'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import checkVersion from './versionCheck';


const authGuard = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const authStore = useAuthStore()
  const onlineStore = useOnlineStore()
  
  try {
    await checkVersion();
  } finally {
    if (!authStore.VLtoken) {
      // User is not authenticated, redirect to login page
      next({ name: 'Login' })
    } else {
      if (onlineStore.online) {
        // update webportal store on page switch when logged in
        await useWebportalStore().getWebPortals();  
      }
  
      // User is authenticated, allow access to protected route
      next()
    }
  }

}

export default authGuard